import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueMatomo from 'vue-matomo'

Vue.use(VueMatomo, {
  router: router,
  host: 'https://analytics.neon.dev/',
  siteId: 5,
});

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
  router,
}).$mount('#app');
